import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {

    this.isSending = false
    this.isSent = false
    this.success = document.querySelector('[data-newsletter-form-success]')
      
    this.el.addEventListener('submit', async (e) => {
      e.preventDefault()
      if (this.isSending || this.isSent) return
      this.send()
    })

  }

  async send() {
    this.isSending = true
    const formData = new FormData(this.el)

    const data = {}
    const formDataArray = Array.from(formData)
    formDataArray.forEach(([key, value]) => {
      data[key] = value
    })

    let serial = ''
    formDataArray.forEach(function(f) {
      serial += '&' + f[0] + '=' + f[1]
    })
    fetch(this.el.action + '&c=' + serial,
      {
        method: 'get',
        mode: 'no-cors',
        headers: {'Content-Type': 'application/json'}
      }
    )

    this.success.classList.remove('hidden')
    this.el.classList.add('hidden')


    /*
    this.submit.innerHTML = i18('Envoi en cours..', 'Sending..', 'Senden..')

    const { formAction } = this.el.dataset
    const headers = formAction === 'contact-form' ? { 'Content-Type': 'application/json' } : {}

    const request = await fetch(`/wp-json/custom/v1/${formAction}`, {
      method: 'POST',
      headers,
      body: formAction === 'contact-form' ? JSON.stringify(data) : formData,
    })

    const response = await request.json()
    const { status } = request
    const { message } = response

    if (status === 200) {
      this.submit.innerHTML = i18('Envoyer', 'Send', 'Senden')
      this.success.classList.remove('hidden')
      this.el.classList.add('hidden')
      window.lenis.scrollTo('0')
      this.isSent = true
    } else {
      this.notice.classList.remove('hidden')
      this.noticeMessage.innerHTML = message

      this.submit.innerHTML = i18('Envoyer', 'Send', 'Senden')
      this.isSending = false
    }
    */


  }
  
}
